import {
  GET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY,
  RESET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY,
} from '../../../../Types'

const initialState = {
  data: [],
  totalRecords: 0
}

const MonthWiseDailyTransactionsSummaryReducer = (state = initialState, action) => {
  switch (action.type) {

    case GET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY:
      return {
        ...state,
        data: action.payload.data,
        totalRecords: action.payload.totalRecords
      }

    case RESET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY:
      return initialState

    default:
      return state
  }
}

export default MonthWiseDailyTransactionsSummaryReducer
